import LogoImg from './img/Logo.svg';
const Logo = ({className})=>{
    return <img className={className} src={LogoImg} alt="Logo" />
}
export default Logo;